import React, { createContext, useContext, useState, ReactNode } from 'react';

interface InventoryModalContextType {
  isInventoryModalOpen: boolean;
  openInventoryModal: (initialTab?: string) => void;
  closeInventoryModal: () => void;
  onInventoryUpdate?: (inventoryType: string) => void;
  setOnInventoryUpdate: (callback: (inventoryType: string) => void) => void;
  currentVersions?: Record<string, string>;
  setCurrentVersions: (versions: Record<string, string>) => void;
  inventoryStatuses?: any[];
  setInventoryStatuses: (statuses: any[]) => void;
  initialTab?: string;
}

const InventoryModalContext = createContext<InventoryModalContextType | undefined>(undefined);

export const useInventoryModal = () => {
  const context = useContext(InventoryModalContext);
  if (context === undefined) {
    throw new Error('useInventoryModal must be used within an InventoryModalProvider');
  }
  return context;
};

interface InventoryModalProviderProps {
  children: ReactNode;
}

export const InventoryModalProvider: React.FC<InventoryModalProviderProps> = ({ children }) => {
  const [isInventoryModalOpen, setIsInventoryModalOpen] = useState(false);
  const [onInventoryUpdate, setOnInventoryUpdate] = useState<((inventoryType: string) => void) | undefined>(undefined);
  const [currentVersions, setCurrentVersions] = useState<Record<string, string> | undefined>(undefined);
  const [inventoryStatuses, setInventoryStatuses] = useState<any[]>([]);
  const [initialTab, setInitialTab] = useState<string | undefined>(undefined);

  const openInventoryModal = (tab?: string) => {
    setInitialTab(tab);
    setIsInventoryModalOpen(true);
  };

  const closeInventoryModal = () => {
    setIsInventoryModalOpen(false);
  };

  return (
    <InventoryModalContext.Provider
      value={{
        isInventoryModalOpen,
        openInventoryModal,
        closeInventoryModal,
        onInventoryUpdate,
        setOnInventoryUpdate,
        currentVersions,
        setCurrentVersions,
        inventoryStatuses,
        setInventoryStatuses,
        initialTab,
      }}
    >
      {children}
    </InventoryModalContext.Provider>
  );
}; 